import { useMemo } from 'react';

import { useFormContext } from 'react-hook-form';
import { Chip } from 'shared/mui/Chips';
import { useFilterContext } from 'shared/mui/Filter/context/filterContext';
import { getLimitTagsText } from 'utils/getLimitTagsText';

export type FilterIdChipProps = {
  label: string;
  name: string;
  limitTags?: number;
  onClick?: () => void;
};

export const FilterIdChip: React.FC<FilterIdChipProps> = ({ name, label, onClick, limitTags }) => {
  const { setAppliedFilter, appliedFilters } = useFilterContext();
  const { setValue } = useFormContext();

  const tags = useMemo(() => {
    return getLimitTagsText(appliedFilters[name] || [], limitTags);
  }, [appliedFilters[name]]);

  if (!appliedFilters[name] || !appliedFilters[name].length) {
    return <></>;
  }

  return (
    <>
      <Chip
        label={`${label}: ${tags}`}
        onClick={onClick}
        onDelete={() => {
          setValue(name, []);
          setAppliedFilter(name, []);
        }}
        size="medium"
      />
    </>
  );
};
